(function () {
    'use strict';

    function requestForProposalResponsesController($scope, $timeout, $state, $log, $uibModal, $window, $filter,
        notifyService, requestForProposalStateService, requestForProposalResponseDataService, scrollingService,
        sessionData, rfpResponses, milestones, mailRequestDataService, milestoneModalService) {

        var vm = this;
        vm.rfpData = requestForProposalStateService.get();
        vm.rfpId = vm.rfpData.Id.split('/')[1];
        vm.rfpResponses = rfpResponses;
        vm.sessionData = sessionData;

        vm.responseStatuses = [
            "ApplicationNotStarted",
            "ApplicationInProgress",
            "ApplicationSubmitted"
        ];

        vm.awardStatuses = [
            "InReview",
            "Selected",
            "NotSelected"
        ];

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            $timeout(function () {
                if (toState.name === 'rfp.responses.single') {
                    scrollingService.scrollTo('requestforproposalresponses-' + toParams.rfpResponseId, 0, 0, 0);
                }
            });
        });

        vm.contactRespondent = function (entity) {
            mailRequestDataService.sendConnectionRequest({
                RequesterEntityId: sessionData.EntityId,
                RequesteeEntityId: entity.Id
            }).then(function(data) {
                notifyService.notify('We sent a notification to ' + entity.CompanyDetails.Name);
            });
        }

        vm.updateResponseAvailabilityStatus = function(response) {
            notifyService.notify('You marked the application for ' +
                response.RequestForProposalResponseEntity.CompanyDetails.Name + 
                ' as ' + (response.IsAvailable ? 'available' : 'not available'));

            var recordedActivity = {
                Date: (new Date()).toISOString(),
                Description: 'The response availability was changed to ' + (response.IsAvailable ? 'available' : 'not available'),
                UsersToNotify: [],
                UserName: vm.sessionData.EntityId
            }
            vm.saveAndSendEmailUpdate(response, recordedActivity);
        }

        vm.updateResponseAwardStatus = function (response) {
            var awardStatusText = $filter('splitToWords')(response.AwardStatus).toLowerCase();
            notifyService.notify('You marked the application for ' +
                response.RequestForProposalResponseEntity.CompanyDetails.Name +
                ' as ' + awardStatusText);

            var recordedActivity = {
                Date: (new Date()).toISOString(),
                Description: 'The response award status was changed to ' + awardStatusText,
                UsersToNotify: [],
                UserName: vm.sessionData.EntityId
            }
            vm.saveAndSendEmailUpdate(response, recordedActivity);
        }

        vm.saveAndSendEmailUpdate = function(response, recordedActivity) {
            requestForProposalResponseDataService.saveRequestForProposalResponse(response).then(function (data) {
                // send email to respondent
                mailRequestDataService.sendRequestForProposalRespondentUpdate({
                    RequestForProposalId: vm.rfpData.Id,
                    RequestForProposalResponseId: response.Id,
                    EntityId: vm.sessionData.EntityId,
                    RecordedActivity: recordedActivity
                });

                // send email to admins
                mailRequestDataService.sendRequestForProposalResponseUpdate({
                    RequestForProposalId: vm.rfpData.Id,
                    RequestForProposalResponseId: response.Id,
                    EntityId: vm.sessionData.EntityId,
                    RecordedActivity: recordedActivity
                });
            });
        }

        vm.openProposal = function (entity) {
            var response = vm.rfpResponses.find(function (response) {
                return response.RequestForProposalResponseEntity.Id === entity.Id;
            });

            if (!response) {
                notifyService.notify('Could not find response', true);
                $log.error('Could not find response for applicant ' + entity.Id);
            }
            else {
                $state.go('rfp.responses.single.details',
                    { rfpId: vm.rfpData.Id.split('/')[1], rfpResponseId: response.Id.split('/')[1] });
            }
        }

        vm.openDeleteAlert = function (entity) {
            var response = vm.rfpResponses.find(function (response) {
                return response.RequestForProposalResponseEntity.Id === entity.Id;
            });

            var modalInstance = $uibModal.open({
                templateUrl: 'deleteRequestForProposalResponseModal',
                controller: 'deleteRequestForProposalResponseModalController',
                resolve: {
                    rfpResponseId: function () {
                        return response.Id;
                    },
                    entityName: function() {
                        return entity.CompanyDetails.Name
                    }
                }
            });

            return modalInstance.result.then(function (wasDeleted) {
                if (wasDeleted) {
                    var removedResponse = vm.rfpResponses.find(function(rfpResponse) {
                        return rfpResponse.Id === response.Id;
                    });

                    vm.rfpResponses.splice(vm.rfpResponses.indexOf(removedResponse), 1);
                }
            });
        }

        vm.responseActions = {
            contactRespondent: {
                label: "Contact",
                call: vm.contactRespondent
            },
            showProposal: {
                label: "View",
                call: vm.openProposal
            },
            deleteProposal: {
                label: "Delete",
                call: vm.openDeleteAlert,
                cssClass: "md-warn"
            }
        }

    }

    requestForProposalResponsesController.$inject = ['$scope', '$timeout', '$state', '$log', '$uibModal', '$window', '$filter',
        'notifyService', 'requestForProposalStateService', 'requestForProposalResponseDataService', 'scrollingService',
        'sessionData', 'rfpResponses', 'milestones', 'mailRequestDataService', 'milestoneModalService'];

    angular.module('ecap.requestForProposal').controller('requestForProposalResponsesController', requestForProposalResponsesController);
})();
